export const COLORS = ['mauve', 'turquoise', 'orange', 'red'];
export const MAIN_COLOR = 'grey';

export const getColorByName = (name?: string) => {
  if (!name) return COLORS[0];
  const firstLetter = name.charAt(0).toUpperCase();
  const charCode = firstLetter.charCodeAt(0) - 65;
  const imageIndex = Math.floor(charCode / 7);
  return COLORS[imageIndex];
};
